import { Action } from '@ngrx/store';
import { RmsOrderResponse } from '@cemex-core/cmx-api';

export enum SimulateActionTypes {
  LOAD = '[Rms Simulate] Load simulate',
  LOAD_COMPLETE = '[Rms Simulate] Load complete simulate',
  RESET = '[Rms Simulate] Reset',
}

export class SimulateLoadAction implements Action {
  readonly type = SimulateActionTypes.LOAD;

  constructor() {}
}

export class SimulateLoadCompleteAction implements Action {
  readonly type = SimulateActionTypes.LOAD_COMPLETE;

  constructor(public payload: RmsOrderResponse) {}
}

export class SimulateResetAction implements Action {
  readonly type = SimulateActionTypes.RESET;

  constructor() {}
}

export type SimulateActions = SimulateLoadAction | SimulateLoadCompleteAction | SimulateResetAction;
